import React from "react";
import PropTypes from "prop-types";

import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import Button from "../../Parts/Button";

import DialogModal from "../../common/DialogModal";

const styles = () => ({
  text: {
    marginBottom: "40px",
    textAlign: "left",
  },

  button: {
    background: "#F03A47",
    "&:hover::before": {
      backgroundColor: "#F03A47",
      opacity: 0.6,
    },
  },

  contentContainer: {
    padding: "50px 40px",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "450px",
    boxSizing: "border-box",
    background: "#FFFFFF",
  },

  buttonContainer: {
    display: "inline-flex",
    width: "100%",
    justifyContent: "space-evenly",
  },
});

class ConfirmDeleteDialog extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (this.props.isLoading && !nextProps.isLoading) {
      this.props.toggleDialog();
    }
  }

  handleClick = () => {
    this.props.action();
  };

  render() {
    const { classes, isOpen, toggleDialog, buttonText, name, itemName } = this.props;

    return (
      <DialogModal
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          contentContainer: classes.contentContainer,
        }}
      >
        <Typography variant="subheading" className={classes.text}>
          「{name}」の{itemName}情報を削除します。よろしいですか？
        </Typography>
        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={toggleDialog}
            text="キャンセル"
            type="ghost"
          ></Button>
          <Button
            handleClickButton={this.handleClick}
            text={buttonText}
            loading={this.props.isLoading}
          ></Button>
        </div>
      </DialogModal>
    );
  }
}

ConfirmDeleteDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  action: PropTypes.func.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  isLoading: PropTypes.bool,
  buttonText: PropTypes.string,
  name: PropTypes.string,
  itemName: PropTypes.string,
};

export default withStyles(styles)(ConfirmDeleteDialog);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Basic/ConfirmDeleteDialog.jsx